import {
  TableCell,
  TableHead,
  TableRow,
  Box,
  Typography,
  IconButton,
  Tooltip,
  TableBody,
  makeStyles,
  Collapse,
  Chip,
  Hidden,
  ListItem,
  List,
  Icon,
} from "@material-ui/core";
import { CustomTable } from "../custom-table";
import { ExpandMoreRounded } from "@material-ui/icons";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import DeleteOutlineOutlinedIcon from "@material-ui/icons/DeleteOutlineOutlined";
import { useState } from "react";
import LinkButton from "../link-button";

export default function RefillCategoryTable(props) {
  const { data, deleteLoading, handleOnDelete } = props;
  const classes = useStyles();
  const [controlCollapse, setControlCollapse] = useState(new Set());

  return (
    <CustomTable
      propsTable={{
        id: "RefillCategoriesTable",
        style: { tableLayout: "fixed" },
        className: classes.table,
      }}
    >
      <TableHead>
        <TableRow>
          <TableCell className={classes.cell}>
            <Box className={classes.nameCell}>
              <Box>
                <IconButton
                  onClick={() =>
                    setControlCollapse((prev) => {
                      const newState = new Set(prev);
                      newState.clear();
                      return newState;
                    })
                  }
                >
                  <ExpandMoreRounded
                    style={{
                      color: "white",
                      transition: "transform 0.2s ease",
                      transform:
                        controlCollapse.size > 0
                          ? "rotate(180deg)"
                          : "rotate(0)",
                    }}
                  />
                </IconButton>
              </Box>
              <Box>
                <Typography>Nombre</Typography>
              </Box>
            </Box>
          </TableCell>
          <TableCell className={classes.cell} width={"15%"}>
            <Box>
              <Typography>Tipo</Typography>
            </Box>
          </TableCell>
          <TableCell className={classes.cell} width={"15%"}>
            <Box>
              <Typography>Cantidad</Typography>
            </Box>
          </TableCell>
          <TableCell className={classes.cell}>
            <Box>
              <Typography>Acciones</Typography>
            </Box>
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {data.map((cat) => {
          const { _id, name, refillTo, type, products } = cat;
          const expand = controlCollapse.has(_id);
          const isDeleting = deleteLoading[_id] ?? false;          
          return (
            <>
              <TableRow
                key={`row-${_id}`}
                data-type="row"
                data-state={expand ? "expand" : ""}
                data-loading={isDeleting ? "loading" : ""}
                className={classes.row}
              >
                <TableCell className={classes.cell} data-id="name">
                  <Box className={classes.nameCell}>
                    <Box>
                      <IconButton
                        {...(type === "basal" ? { disabled: true } : "")}
                        onClick={() =>
                          setControlCollapse((prev) => {
                            const newState = new Set(prev);
                            if (newState.has(_id)) newState.delete(_id);
                            else newState.add(_id);
                            return newState;
                          })
                        }
                      >
                        <ExpandMoreRounded
                          style={{
                            transition: "transform 0.2s ease",
                            transform: controlCollapse.has(_id)
                              ? "rotate(180deg)"
                              : "rotate(0)",
                          }}
                        />
                      </IconButton>
                    </Box>
                    <Box>
                      <Typography data-id="title">{name}</Typography>
                    </Box>
                  </Box>
                </TableCell>
                <TableCell className={classes.cell} data-id="type">
                  <Box>
                    <Hidden smUp>
                      <Typography
                        variant="body2"
                        style={{
                          fontWeight: 600,
                          marginRight: 5,
                          lineHeight: 1.5,
                        }}
                      >
                        Tipo:
                      </Typography>
                    </Hidden>
                    <Chip
                      style={{
                        letterSpacing: "1px",
                        textTransform: "capitalize",
                      }}
                      size="small"
                      label={type}
                      color={type === "basal" ? "primary" : "secondary"}
                    />
                  </Box>
                </TableCell>
                <TableCell className={classes.cell} data-id="refillto">
                  <Box>
                    <Hidden smUp>
                      <Typography
                        variant="body2"
                        style={{
                          fontWeight: 600,
                          marginRight: 5,
                          lineHeight: 1.5,
                        }}
                      >
                        Cantidad:
                      </Typography>
                    </Hidden>
                    {type === "basal" ? (
                      <>
                        <Typography>{refillTo}</Typography>
                      </>
                    ) : (
                      "--"
                    )}
                  </Box>
                </TableCell>
                <TableCell className={classes.cell} data-id="actions">
                  <Box
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Hidden smUp>
                      <Typography
                        variant="body2"
                        style={{
                          fontWeight: 600,
                          marginRight: 5,
                          lineHeight: 1.5,
                        }}
                      >
                        Acciones:
                      </Typography>
                    </Hidden>
                    {type !== "basal" && (
                      <Tooltip arrow placement="top" title="Eliminar categoría">
                        <IconButton onClick={() => handleOnDelete(cat)}>
                          <DeleteOutlineOutlinedIcon />
                        </IconButton>
                      </Tooltip>
                    )}
                    <Tooltip arrow placement="top" title="Editar categoría">
                      <LinkButton
                        isIcon
                        to={{
                          pathname: "/refill/update/",
                          search: `?c=${cat._id}&t=${cat.type}`,
                        }}
                      >
                        <Icon>
                          <EditOutlinedIcon />
                        </Icon>
                      </LinkButton>
                    </Tooltip>
                  </Box>
                </TableCell>
              </TableRow>
              <TableRow key={`row-collapsable-${_id}`} data-type="collapsable">
                <TableCell
                  style={{ padding: 0, overflow: "hidden" }}
                  colSpan={4}
                >
                  <Collapse in={expand}>
                    <Box className={classes.collapse_content}>
                      <List>
                        <ListItem
                          className={classes.list_item}
                          data-id="header-list"
                        >
                          <Box className={classes.list_content}>
                            <Typography>Nombre producto</Typography>
                            <Typography data-id="qty">Cantidad</Typography>
                          </Box>
                        </ListItem>
                        {products.map((item) => {
                          const {
                            refillTo,
                            productInfo: { _id: productId, name: productName },
                          } = item;
                          return (
                            <ListItem
                              key={`${cat._id}-${productId}`}
                              className={classes.list_item}
                            >
                              <Box className={classes.list_content}>
                                <Typography>{productName}</Typography>
                                <Typography data-id="qty">
                                  {refillTo}
                                </Typography>
                              </Box>
                            </ListItem>
                          );
                        })}
                      </List>
                    </Box>
                  </Collapse>
                </TableCell>
              </TableRow>
            </>
          );
        })}
      </TableBody>
    </CustomTable>
  );
}

const useStyles = makeStyles((theme) => ({
  cell: {
    padding: theme.spacing(0.5),
  },
  nameCell: {
    display: "grid",
    gridTemplateColumns: "0.5fr 1fr",
    alignItems: "center",
    justifyItems: "start",
    [theme.breakpoints.down("xs")]: {
      '& p[data-id="title"]': {
        fontSize: "1.08rem",
      },
    },
  },
  collapse_content: {
    paddingInline: theme.spacing(3),
    textAlign: "start",
  },
  list_item: {
    padding: 0,
    borderBottom: `1pt solid ${theme.palette.grey[300]}`,
    '&[data-id="header-list"]': {
      backgroundColor: `hsl(from ${theme.palette.secondary.main} h s calc(l + 50))`,
      paddingTop: theme.spacing(0.5),
      paddingBottom: theme.spacing(0.5),
    },
  },
  list_content: {
    display: "grid",
    gridTemplateColumns: "1fr 0.5fr",
    gap: theme.spacing(1.5),
    width: "100%",
    '& [data-id="qty"]': {
      justifySelf: "end",
    },
  },
  table: {
    "& tbody": {
      "& tr": { border: "none", borderRadius: theme.spacing(2) },
      '& tr[data-type="row"]': {
        '& td[data-id="name"]': {
          textAlign: "start",
        },
        '&[data-loading="loading"]': {
          pointerEvents: "none",
          filter: "contrast(0.5) opacity(0.7)",
          '&>*':{
            pointerEvents: "none",
          }
        },
        [theme.breakpoints.down("xs")]: {
          backgroundColor: `hsl(from ${theme.palette.primary.main} h s calc(l + 65))`,
          margin: 0,
          transition: "border-radius 0.2s ease 0.1s",
          '& td[data-id="name"]': {
            gridColumn: "span 2",
          },
          '& td[data-id="refillto"]': {
            "&>div": {
              display: "flex",
              alignItems: "center",
            },
          },
          '& td[data-id="type"]': {
            "&>div": {
              display: "flex",
              alignItems: "center",
            },
          },
          '& td[data-id="actions"]': {
            gridColumn: "span 2",
            "&>div": {
              display: "flex",
              alignItems: "center",
            },
          },
          '&[data-state="expand"]': {
            transition: "none",
            borderBottomRightRadius: 0,
            borderBottomLeftRadius: 0,
          },
        },
      },
      '& tr[data-type="collapsable"]': {
        [theme.breakpoints.down("xs")]: {
          backgroundColor: `hsl(from ${theme.palette.primary.main} h s calc(l + 65))`,
          padding: 0,
          marginBottom: theme.spacing(2),
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
        },
      },
    },
  },
}));
